module.exports = __webpack_public_path__ + "img/loading.32902bf5.png";